export default (theme) => ({
  desktopStepperForm: {
    marginTop: theme.custom.marginTop,
    [theme.breakpoints.down('xl')]: {
      marginTop: 100,
    },
  },
  desktopFormWrapper: {
    position: 'relative',
    zIndex: 100,
    margin: '0 0 40px 40px',
    background: theme.palette.background.white,
    padding: 48,
    borderRadius: 33,
    boxShadow: theme.custom.boxShadow,
    WebkitBoxShadow: theme.custom.boxShadow,
    [theme.breakpoints.down('xl')]: {
      padding: 30,
    },
    [theme.breakpoints.down('ml')]: {
      margin: '0 0 30px 30px',
      padding: 25,
    },
  },
});
